export default 'M1 5a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3H7.414l-3 3C3.154 23.26 1 22.368 1 20.586V5Zm3-1a1 1 0 0 0-1 1v15.586l3.293-3.293A1 1 0 0 1 7 17h13a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H4Z';
